export default {
  ebookPage: {
    all: { ID: 772, CN: "全部", TR: "Все" },
    driveType: { ID: 1066, CN: "驱动类型", TR: "Тип привода" },
    motor: { ID: 830, CN: "电机", TR: "Двигатель" },
    diesel: { ID: 1069, CN: "柴油机", TR: "Дизельный двигатель" },
    noProfile: { ID: 2367, CN: "暂无简介", TR: "Нет профиля" },
    serieslist: { ID: 1, CN: "电子样本", TR: "Список продуктов" },
    motorFrequency: { ID: 72, CN: "电机频率", TR: "Частота двигателя" },
    motorStandard: { ID: "", CN: "单位频率", TR: "частота электродвигателя" },
    displayMode: { ID: 664, CN: "显示方式", TR: "Режим отображения" },
    list: { ID: 665, CN: "列表", TR: "Список" },
    grid: { ID: 666, CN: "网格", TR: "Сетка" },
    keyWord: { ID: 661, CN: "关键字", TR: "Ключевые слова" },
    keyWordRule: {
      ID: 1003,
      CN: "请输入关键字",
      TR: "Пожалуйста введите ключевые слова",
    },
    view: { ID: 251, CN: "查询", TR: "Параметры запроса" },
    queryResults: { ID: 2368, CN: "查询结果", TR: "Результаты запроса" },
    operation: { ID: 1012, CN: "操作", TR: "Работать" },
    download: { ID: 448, CN: "下载", TR: "Скачать" },
    type: { ID: 246, CN: "类型", TR: "Тип" },
    name: { ID: 446, CN: "名称", TR: "Имя" },
    updateTime: { ID: 758, CN: "更新时间", TR: "Время обновления" },
    version: { ID: 759, CN: "文件版本", TR: "Версия файла" },
    lang: { ID: 449, CN: "语言", TR: "Язык" },
    size: { ID: 1489, CN: "文件尺寸", TR: "Размер файла" },
    desc: { ID: 447, CN: "描述", TR: "Описание" },
    emptyFlowAndHead: {
      ID: 2426,
      CN: "流量和扬程不能为空",
      TR: "расход и напор не могут быть пустыми",
    },
    details: { ID: 983, CN: "详情", TR: "подробности" },
    noData: { ID: "", CN: "暂无数据", TR: "Пока нет данных" },
    pumpList: { ID: 123, CN: "水泵列表", TR: "Список насосов" },
    spectrumList: { ID: 6, CN: "系列型谱", TR: "Спектральный список" },
    modelDrawing: { ID: 183, CN: "实物图", TR: "Рисунок модели " },
    seriesDescription: { ID: 145, CN: "系列说明", TR: "Описание серии" },
    seriesDocuments: { ID: 687, CN: "系列文档", TR: "Документы серии" },
    video: { ID: 688, CN: "详情视频", TR: "видео" },
    picture: { ID: "",CN: "图片", TR: "Фотографии" },
    model_3D: { ID: 132, CN: "三维模型", TR: "3D-модель" },
    export: { ID: 277, CN: "导出", TR: "Экспорт" },
    no: { ID: 689, CN: "序号", TR: "No" },
    flow: { ID: 47, CN: "流量", TR: "Расход" },
    head: { ID: 48, CN: "扬程", TR: "Напор" },
    catalog: { ID: 2337, CN: "按类型", TR: "по типу" },
    selectIndustry: {
      ID: 2369,
      CN: "选择行业",
      TR: "Выбрать область примения",
    },
    choosePump: { ID: "", TR: "选择泵业", TR: " Выберите насосную отрасль" }, //yy加一个选择泵业
    allSeries: { ID: 1963, CN: "所有系列", TR: "все серии" },
    productStructure: { ID: "", CN: "产品结构", TR: "Структура продукции" },
    screen: { ID: "", CN: "筛选", TR: "сито" },
    search: { ID: 177, CN: "搜索", TR: "Поиск" },
    deviceList: { ID: "", CN: "设备列表", TR: "Список устройств" },
  },
  // 选型界面
  selectPage: {
    basicParameters: { ID: 1846, CN: "基本参数", TR: "Основные параметры" },
    drive: { ID: "", CN: "驱动", TR: "Двигатель" },
    acceptanceTolerance: { ID: "", CN: "验收容差", TR: "Допуск к приемке" },
    toleranceStandard: { ID: "", CN: "容差标准", TR: "Норма допуска" },
    toleranceLevel: { ID: "", CN: "容差等级", TR: "Класс допуска" },
    flowRange: { ID: "", CN: "流量范围", TR: "Диапазон потока" },
    headRange: { ID: "", CN: "扬程范围", TR: "Диапазон напора" },
    otherSelectionCriteria: {
      ID: "",
      CN: "其他选型条件",
      TR: "Другие условия отбора",
    },
    applicationArea: { ID: 2339, CN: "应用领域", TR: "Области применения" },
    municipalWaterManagement: { ID: "", CN: "市政", TR: "Муниципалитеты" },
    industrialAndMining: {
      ID: "",
      CN: "工矿",
      TR: "Промышленная и горнодобывающая промышленность",
    },
    constructionApplications: { ID: "", CN: "建筑", TR: "Строительство" },
    filterCriteria: { ID: "", CN: "筛选结果", TR: "Результаты отбора" },

    selparas: { ID: 5, CN: "参数选型", TR: "Подбор по точке" },
    selResult: { ID: 2316, CN: "选型结果", TR: "Результатыподбора" },
    index: { ID: 1451, CN: "首页", TR: "Стартовая страница" },
    selRow: { ID: 724, CN: "列选择", TR: "Выбор колонки" },
    export: { ID: 277, CN: "导出", TR: "Экспорт" },
    print: { ID: 193, CN: "打印", TR: "Распечатать" },
    previous: { ID: 367, CN: "上一步", TR: "Предыдущий шаг" },
    physical: { ID: 183, CN: "实物图", TR: "Внешний вид" },
    series: { ID: 254, CN: "系列", TR: "Серии" },
    model: { ID: 100, CN: "型号", TR: "Модель" },
    diagram: { ID: 766, CN: "曲线图", TR: "Диаграмма" },
    flow: { ID: 47, CN: "流量", TR: "Расход" },
    head: { ID: 48, CN: "扬程", TR: "Напор" },
    shaftPower: { ID: 109, CN: "轴功率", TR: "Мощность на валу" },
    efficiency: { ID: 108, CN: "效率", TR: "КПД" },
    inputPower: { ID: "", CN: "输入功率", TR: "Входная мощность" },
    unitEfficiency: { ID: "", CN: "机组效率", TR: "КПД агрегата" },
    npsh: { ID: 110, CN: "汽蚀", TR: "NPSHr" },
    speed: { ID: 115, CN: "转速", TR: "Скорость" },
    impellerDiameter: {
      ID: 224,
      CN: "叶轮直径",
      TR: "Диаметр рабочего колеса",
    },
    details: { ID: 983, CN: "详情", TR: "подробности" },
    certifiedTraffic: {
      ID: "",
      CN: "认证流量",
      TR: "Сертифицированный расход",
    },
    certifiedHead: { ID: "", CN: "认证扬程", TR: "Сертифицированный напор" },
    certifiedSpeed: { ID: "", CN: "认证转速", TR: "установить обороты" },
    pointFlow_150: { ID: "", CN: "150%点流量", TR: "Расход в точке 150%" },
    pointLift_150: { ID: "", CN: "150%点扬程", TR: "Напор в точке 150%" },
    pointPower_150: { ID: "", CN: "150%点功率", TR: "Мощность в точке 150%" },
    maxShaftPower: {
      ID: "",
      CN: "最大轴功率",
      TR: "Максимальная мощность вала",
    },
    deadCenterLift: {
      ID: 110,
      CN: "关死点扬程",
      TR: "Напор при нулевой подаче",
    },
    pumpStages: { ID: 769, CN: "泵级数", TR: "Ступень насоса" },
    note: { ID: 118, CN: "备注", TR: "Замечания" },
    gotoIndexPage: { ID: 2370, CN: "返回首页", TR: "Вернуться на главную" },
    quickSelection: { ID: 2317, CN: "快速选型", TR: "Быстрый подбор" },
    advancedSelection: { ID: 2318, CN: "高级选型", TR: "Расширенный подбор" },
    workingConditions: { ID: 2319, CN: "工况条件", TR: "Условия эксплуатации" },
    productSeries: { ID: 2320, CN: "产品系列", TR: "Серия продукта" },
    driveType: { ID: 2321, CN: "驱动类型", TR: "Тип привода" },
    setFrequency: { ID: 2322, CN: "设置频率", TR: "Установить частоту" },
    moreDesignPoints: {
      ID: 1443,
      CN: "更多设计点",
      TR: "Дополнительные конструктивные моменты",
    },
    hide: { ID: 2323, CN: "隐藏", TR: "Скрыть" },
    secondDpFlow: {
      ID: 2324,
      CN: "第二设计点流量",
      TR: "Расход второй проектной точки",
    },
    secondDpHead: {
      ID: 2325,
      CN: "第二设计点扬程",
      TR: "Напор второй проектной точки",
    },
    thirdDpFlow: {
      ID: 2326,
      CN: "第三设计点流量",
      TR: "Расход третьей проектной точки",
    },
    thirdDpHead: {
      ID: 2327,
      CN: "第三设计点扬程",
      TR: "Напор третьей проектной точки",
    },
    firePump: { ID: 2289, CN: "消防泵", TR: "Пожарный насос" },
    motorPoleNum: { ID: 2328, CN: "电机级数", TR: "Серия двигателей" },
    moreSet: { ID: 2329, CN: "更多设置", TR: "Дополнительные настройки" },
    put: { ID: 2330, CN: "收起", TR: "Убрать" },
    expand: { ID: "",CN:"展开", TR: "Развернуть" },
    motorPowerStd: {
      ID: 2331,
      CN: "电机功率标准",
      TR: "Стандартная мощность двигателя",
    },
    mediaName: { ID: 2332, CN: "介质名称", TR: "Название рабочей среды" },
    mediumTemperature:{ID:"",CN:"介质温度",TR:"Температура среды"},
    cleanWater: { ID: 464, CN: "清水", TR: "Чистая вода" },
    maxTemperature: {
      ID: 2333,
      CN: "最高温度",
      TR: "Максимальная температура",
    },
    customMediaProp: {
      ID: 2334,
      CN: "自定义介质属性",
      TR: "Пользовательские свойства рабочей среды",
    },
    maxDensity: { ID: 2335, CN: "最大密度", TR: "Максимальная плотность" },
    mediumViscosity: { ID: 2336, CN: "介质粘度", TR: "Вязкость среды" },
    nextStep: { ID: 368, CN: "下一步", TR: "Следующий шаг" },
    selectAll: { ID: 97, CN: "全选", TR: "Выбрать все" },
    reselect: { ID: 366, CN: "重选", TR: "Выбирать" },
    invert: { ID: "", CN: "反选", TR: "избрание" },
    modelList: { ID: 442, CN: "型号列表", TR: "Список моделей" },
    byType: { ID: 2337, CN: "按类型", TR: "По типу" },
    byIndustry: { ID: 2338, CN: "按行业", TR: "По областям" },
    byMedia: { ID: 2371, CN: "按介质", TR: "По среднему" },
    type: { ID: 246, CN: "类型", TR: "Тип" },
    applicationArea: { ID: 2339, CN: "应用领域", TR: "Область применения" },
    flowRule: { ID: 2553, CN: "请输入流量", TR: "Пожалуйста введите расход" },
    headRule: { ID: 1149, CN: "请输入扬程", TR: "Пожалуйста введите напор" },
    leastOneType: {
      ID: "",
      CN: "至少选择一种类型",
      TR: "Минимально выбрать одну модель",
    },
    seriesRule: {
      ID: 2342,
      CN: "至少选择一个系列",
      TR: "выбрать хотя бы одну серию",
    },
    hangyeRule: {
      ID: 2372,
      CN: "至少选择一个行业",
      TR: "Выберите хотябы одну отрасль",
    },
    jiezhiRule: {
      ID: 2373,
      CN: "至少选择一种介质",
      TR: "Выберите хотя бы один носитель",
    },
    dieselEngineSpeedRule: {
      ID: 2341,
      CN: "请输入柴油机转速",
      TR: "Пожалуйста введите частоту вращения дизельного двигателя",
    },
    dieselEngineSpeed: {
      ID: 2340,
      CN: "柴油机转速",
      TR: "Частота вращения вала дизельного двигателя",
    },
    pleaseSelect: { ID: 2022, CN: "请选择", TR: "Пожалуйста выберите" },
    custom: { ID: 2180, CN: "自定义", TR: "Настройка пользователя" },
    unlimited: { ID: "", CN: "不限", TR: "Без ограничения" },
    drivingConditions: { ID: "", CN: "驱动条件", TR: "условия привода" },
    toleranceRange: {
      ID: 51,
      CN: "容差范围",
      TR: "Ввод допустимого диапазона не является приемлемым",
    },
    toleranceStand: {
      ID: "",
      CN: "验收容差标准",
      TR: "Стандарт емкости при приемке",
    },
    toleranceGrade: {
      ID: "",
      CN: "验收容差等级",
      TR: "Уровень расхождения емкости",
    },
    MinFlowPercentage: {
      ID: 677,
      CN: "最小流量百分比",
      TR: "процент минимального расхода",
    },
    MaxFlowPercentage: {
      ID: 678,
      CN: "最大流量百分比",
      TR: "процент максимального расхода",
    },
    MinHeadPercentage: {
      ID: 679,
      CN: "最小扬程百分比",
      TR: "процент наименьшего напора",
    },
    MaxHeadPercentage: {
      ID: 680,
      CN: "最大扬程百分比",
      TR: "максимальный напор",
    },
    findErr1: {
      ID: "",
      CN: "未查找到相关型号,请修改相关选型参数",
      TR: "Не найдена соответствующая модель, пожалуйста, измените соответствующие параметры по выбору модели",
    },
    findErr2: {
      ID: "",
      CN: "未查找到相关型号,将在三秒后返回上一页",
      TR: "Не найдена соответствующая модель, будет возвращаться на предыдущую страницу через три секунды",
    },
    seriesTips: {
      ID: "",
      CN: "请选择合适的产品",
      TR: "Выберите подходящий продукт",
    },
    seriesRangTips: {
      ID: "",
      CN: "请选择合适的产品系列",
      TR: "Выберите подходящую серию",
    },
    seriesRange: { ID: "", CN: "系列范围", TR: "диапазон" },
    QPerQBep: { ID: "", CN: "额定点", TR: "Номинальная фиксированная точка" },
    PerRated: {
      ID: "",
      CN: "铭牌参数综合偏差",
      TR: "значение отклонения параметров таблички",
    },
    PerRatedQ: { ID: "", CN: "铭牌参数流量偏差",TR:"отклонение потока по параметрам таблички" },
    sortMethod: { ID: 1225, CN: "排序方式", TR: "Порядок сортировки" },
    efficiencySort: {
      ID: "",
      CN: "效率排序",
      TR: "Сортировка по эффективности",
    },
    qPerQBepSort: { ID: 2304, CN: "综合排序", TR: "Комплексное сортирование" },
    enum: { ID: 331, CN: "数量", TR: "Количество" },
    modelSelection: { ID: 26, CN: "选型", TR: "Подбор" },
    mediaLibrary: { ID: "", CN: "介质库", TR: "Библиотека диэлектриков" },
    volumeConcentration: { ID: "", CN: "体积浓度", TR: "Концентрация объема" },
    mediaDescription: { ID: "", CN: "介质说明", TR: "Описание среды" },
    isMediumParticles: {
      ID: "",
      CN: "含有介质颗粒",
      TR: "Есть ли частицы среды",
    },

    vbr: { ID: "", CN: "变速率", TR: "VBR" },
    cuttingRate: { ID: "", CN: "切割率", TR: "Коэффициент резания" },
    salesPrice: { ID: "", CN: "销售价", TR: "Продажная цена" },
    originalImpellerDiameter: {
      ID: "",
      CN: "原始叶轮直径",
      TR: "Первоначальный диаметр крыльчатки",
    },
    ratedSpeed: { ID: "", CN: "额定转速", TR: "Номинальная скорость вращения" },
    guidePrice: { ID: "", CN: "指导价", TR: "Ориентировочная цена" },
    secondDirectory: { ID: "", CN: "二级目录", TR: "Каталог второго уровня" },
    allowCutting: { ID: "", CN: "允许切割", TR: "Разрешить резку" },
    allowFrequencyConversion: {
      ID: "",
      CN: "允许变频",
      TR: "Допустимое преобразование частоты",
    },
    efficiencyAndNPSH: { ID: "", CN: "效率和汽蚀", TR: "Эффективность и кавитация" },
    minimumEfficiency: { ID: "", CN: "最低效率", TR: "Минимальная эффективность" },
    attributeFiltering: { ID: "", CN: "属性过滤", TR: "Фильтр свойств" },
    importedCaliber: { ID: "", CN: "进口口径", TR: "Импортный калибр" },
    exportCaliber: { ID: "", CN: "出口口径", TR: "Экспортный калибр" },
    motorParameters: { ID: "", CN: "电机参数", TR: "Электрические параметры" },
    helpChoose: { ID: "", CN: "帮我选", TR: "Помоги мне выбрать." },

    similarConversion:{ID:"",CN:"相似换算",TR:"Аналогичное преобразование"},
    parameterDesign:{ID:"",CN:"参数设计",TR:"Параметры"},
    selectionCondition:{ID:"",CN:"选型条件",TR:"Условия выбора"},
    designRequirement:{ID:"",CN:"设计要求",TR:"Проектные требования"},
    calculationParameters:{ID:"",CN:"计算参数",TR:"Расчетные параметры"},
    mediumDensity:{ID:"",CN:"介质密度",TR:"Плотность среды"},
    selectionMethod:{ID:"",CN:"选型方法",TR:"Метод отбора"},
    pumpType:{ID:"",CN:"泵型",TR:"Тип насоса"},
    impellerType:{ID:"",CN:"叶轮类型",TR:"Тип крыльчатки"},
    modelLibrary:{ID:"",CN:"模型库",TR:"Библиотека моделей"},
    fixedSpeed:{ID:"",CN:"定转速",TR:"Постоянная скорость вращения"},
    specificSpeed:{ID:"",CN:"比转速",TR:"NS"},
    convertRangeBySpecificSpeed:{ID:"",CN:"比转速换算范围",TR:"NSДиапазон преобразования"},
    efficiencyCorrection:{ID:"",CN:"效率修正",TR:"Корректировка эффективности"},
    recommendModel:{ID:"",CN:"推荐模型",TR:"Рекомендуемая модель"},
    DifferenceInSpecificSpeed:{ID:"",CN:"比转速差值",TR:"NS Разница"},
    originalModelInformation:{ID:"",CN:"原模型信息",TR:"Информация о прототипе"},
    afterConversion:{ID:"",CN:"换算后",TR:"После пересчета"},
    scaleRatio:{ID:"",CN:"缩放系数",TR:"Коэффициент масштабирования"},
    yelunTips: { ID: "", CN: "请输入叶轮直径",TR:"Введите диаметр колеса."},
    e_requirements:{ID:"",CN:"效率要求",TR:"Требования к эффективности"},
    currentMotorPower:{ID:"",CN:"当前电机功率",TR:"Текущая мощность двигателя"},
    requiredMotorPower:{ID:"",CN:"要求的电机功率",TR:'Требуемая мощность двигателя'}, 
  },
  //详情页面
  detailPage: {
    userUnit: {
      ID: 2117,
      CN: "用户单位",
      TR: "Пользовательская единица измерения",
    },
    standardUnit: {
      ID: 2118,
      CN: "标准单位",
      TR: "Системная единица измерения",
    },
    report: { ID: 692, CN: "报告", TR: "Отчёт" },
    share: { ID: 693, CN: "分享", TR: "Поделиться" },
    costAnalysis: { ID: 570, CN: "成本分析", TR: "Анализ цен" },
    medium: { ID: 1448, CN: "介质", TR: "Среда" },
    model_3D: { ID: 132, CN: "三维模型", TR: "3D-модель" },
    motorPower: { ID: 682, CN: "电机功率", TR: "Мощность двигателя" },
    scanQRShare: { ID: 2354, CN: "扫描二维码分享", TR: "Сканируйте QR-код" },
    view: { ID: 251, CN: "查询", TR: "Посмотреть" },
    close: { ID: 459, CN: "关闭", TR: "Закрыть" },
    setUp: { ID: 469, CN: "设定", TR: "Настроить" },
    flowUnits: { ID: 2102, CN: "流量单位", TR: "Единицы измерения расхода" },
    headUnit: { ID: 2103, CN: "扬程单位", TR: "Единицы измерения напора" },
    powerUnit: { ID: 2355, CN: "功率单位", TR: "Силовой агрегат" },
    npshUnit: { ID: "", CN: "汽蚀单位", TR: "Единица паровой кавитации" },
    d2Unit: {
      ID: "",
      CN: "叶轮外径单位",
      TR: "Единица внешнего диаметра рабочего колеса",
    },
    followSystem: { ID: "", CN: "跟随系统", TR: "Сопроводительная система" },
    exitFull: {
      ID: 2356,
      CN: "退出全屏",
      TR: "Выход из полноэкранного режима",
    },
    partNo: { ID: 159, CN: "产品编号", TR: "Идентификатор" },
    materialGroup: { ID: 1715, CN: "材料组", TR: "Группа материалов" },
    material: { ID: 1199, CN: "材料", TR: "Материал" },
    selectionReport: { ID: 237, CN: "选型报告", TR: "Лист данных" },
    lang: { ID: 449, CN: "语言", TR: "Язык" },
    fileFormat: { ID: 1547, CN: "文件格式", TR: "Формат файла" },
    buildFile: { ID: 2343, CN: "生成文件", TR: "Создать файл" },
    customerInfo: { ID: 780, CN: "客户信息", TR: "Информация о клиенте" },
    orderInformation: { ID: 866, CN: "订单信息", TR: "Запрос информации" },
    setReportContent: {
      ID: 871,
      CN: "设置报告内容",
      TR: "Настройка содержимого отчета",
    },
    reportInformation: { ID: "", CR: "报告信息",TRl:"Представление информации" },
    projectInformation: { ID: 89, CN: "项目信息", TR: "Информация о проекте" },
    productName: { ID: 863, CN: "产品名称", TR: "Наименование товара" },
    projectCode: { ID: 1011, CN: "项目编号", TR: "Код проекта" },
    projectName: { ID: 785, CN: "项目名称", TR: "Название проекта" },
    itemNO: { ID: 786, CN: "工位编号", TR: "Номер заказа" },
    customerName: { ID: 865, CN: "客户名称", TR: "Заказчик" },
    customerAddress: { ID: 952, CN: "客户地址", TR: "Адрес клиента" },
    contactPerson: { ID: 753, CN: "联系人", TR: "Контактное лицо" },
    contactInformation: { ID: 35, CN: "联系方式", TR: "Контактная информация" },
    email: { ID: 1803, CN: "邮箱", TR: "Электоронная почта" },
    website: { ID: 1804, CN: "网址", TR: "Сайт" },
    country: { ID: 1805, CN: "国家", TR: "Страны" },
    price: { ID: 868, CN: "产品单价", TR: "Цена продукта" },
    productModel: { ID: "", CN: "订单中产品型号", TR: "Тип в заказе" },
    pumpPeformance: { ID: 1798, CN: "订单号", TR: "Номер заказа" },
    purchaseQuantity: { ID: 870, CN: "购买数量", TR: "Количество" },
    orderNote: { ID: 867, CN: "订单备注", TR: "Примечания к заказу" },
    pageReportSet: {
      ID: 2352,
      CN: "页面报告设置",
      TR: "Настройка страницы",
    },
    isBWDispplay: {
      ID: 804,
      CN: "黑白显示曲线",
      TR: "Включить монохромный режим",
    },
    dataAndCurve: {
      ID: 801,
      CN: "数据表和曲线",
      TR: "Таблица данных и кривая (вставки)",
    },
    curveGraph: { ID: 766, CN: "曲线图", TR: "Диаграмма" },
    sizePicture: { ID: 694, CN: "尺寸图", TR: "Размер изображения" },
    assemblyDrawing: { ID: 134, CN: "安装图", TR: "Сборочный чертеж" },
    modelDrawing: { ID: 183, CN: "实物图", TR: "Внешний вид" },
    explosionDiagram: { ID: "", CN: "爆炸图", TR: "Детализированный чертеж" },
    modelDrawinUnit: {
      ID: 2353,
      CN: "实物图(机组)",
      TR: "Чертёж (единица измерения)",
    },
    structureDrawing: { ID: 185, CN: "结构图", TR: "Конструкция" },
    outlineDrawing: {
      ID: 1199,
      CN: "安装尺寸图",
      TR: "Таблица размеров монтажа",
    },
    pumpDimensions: { ID: "", CN: "泵头尺寸图", TR: "Размер насосной головки" },
    offerText: { ID: 798, CN: "报价文本", TR: "Текст предложения" },
    companyName: { ID: 995, CN: "公司抬头", TR: "Название компании" },
    companyWebsite: { ID: 1801, CN: "公司网址", TR: "Веб-сайт компании" },
    performanceCurve: { ID: 218, CN: "性能曲线", TR: "Отобразить" },
    assemblyDrawingPart: {
      ID: 2344,
      CN: "安装图(单泵)",
      TR: "Сборочный чертеж (одиночный насос)",
    },
    assemblyDrawingSys: {
      ID: 2345,
      CN: "安装图(机组)",
      TR: "Сборочный чертеж (единица измерения)",
    },
    physical: { ID: 183, CN: "实物图", TR: "Внешний вид" },
    parameter: { ID: 111, CN: "参数", TR: "Параметр" },
    productFileName: { ID: 694, CN: "尺寸图", TR: "Dimension picture" }, ///!!!!!!!!!
    data: { ID: 2026, CN: "数据", TR: "Данные" },
    unit: { ID: 526, CN: "单位", TR: "Ед. изм" },
    operatingParameters: { ID: 2126, CN: "运行参数", TR: "Рабочие параметры" },
    parameterQuery: { ID: 2346, CN: "参数查询", TR: "Запрос параметров" },
    installation: { ID: 2169, CN: "安装信息", TR: "Установка" },
    motor: { ID: 2170, CN: "电机信息", TR: "Двигатель" },
    documents: { ID: 687, CN: "系列文档", TR: "Документы серии" },
    properties: { ID: 230, CN: "属性", TR: "Параметры" },
    flow: { ID: 47, CN: "流量", TR: "Расход" },
    head: { ID: 48, CN: "扬程", TR: "Напор" },
    frequency: { ID: "", CN: "频率", TR: "Частота" },
    number: { ID: "", CN: "台数", TR: "Количество рабочих мест" },
    queryParams: { ID: "", CN: "查询参数",TR:"Параметры запроса" },

    seriesConnect: { ID: "", CN: "串联", TR: "Последовательное подключение" },
    parallelConnect: { ID: "", CN: "并联", TR: "Параллельное соединение" },
    method: { ID: "", CN: "方式", TR: "Способ" },
    update: { ID: "", CN: "更新", TR: "Обновление" },

    shaftPower: { ID: 109, CN: "轴功率", TR: "Мощность на валу" },
    efficiency: { ID: 108, CN: "效率", TR: "КПД" },
    inputPower: { ID: "", CN: "输入功率", TR: "Входная мощность" },
    unitEfficiency: { ID: "", CN: "机组效率", TR: "КПД агрегата" },
    press: { ID: 1105, CN: "压力", TR: "Давление" },
    power: { ID: 422, CN: "功率", TR: "Мощность" },
    impellerDia: { ID: 112, CN: "叶轮外径", TR: "Диаметр рабочего колеса" },
    npsh: { ID: 110, CN: "汽蚀", TR: "NPSHr" },
    speed: { ID: 115, CN: "转速", TR: "Частота вращения" },
    coefficient: { ID: "", CN: "系数", TR: "Коэффициент" },
    parameterSelection: { ID: 5, CN: "参数选型", TR: "Подбор по точке" },
    allowableRegionMax: {
      ID: 2347,
      CN: "允许区域(大)",
      TR: "Допустимая область (макс.)",
    },
    allowableRegionMin: {
      ID: 2348,
      CN: "允许区域(小)",
      TR: "Допустимая область (мин.)",
    },
    optimalAreaMax: {
      ID: 2349,
      CN: "最优区域(大)",
      TR: "Оптимальная площадь (макс.)",
    },
    optimalAreaMin: {
      ID: 2350,
      CN: "最优区域(小)",
      TR: "Оптимальная площадь (мин.)",
    },
    closeDeadCenter: { ID: 2351, CN: "关死点", TR: "Закрыть" },
    bestAdvantage: { ID: 2357, CN: "最优点", TR: "Оптимальная точка" },
    workingPoint: { ID: 203, CN: "工作点", TR: "Рабочая точка" },
    flowPoint150: { ID: 2358, CN: "流量150%点", TR: "Точка 150% расхода" },
    powerPointMax: {
      ID: 2359,
      CN: "最大功率点",
      TR: "Точка максимальной мощности",
    },
    video: { ID: 688, CN: "系列视频", TR: "Видео" },
    variableSpeedCurve: {
      ID: 2374,
      CN: "变速曲线",
      TR: "Кривая переменной скорости",
    },
    seriesParallelConnection:{ID: "", CN: "串并联曲线", TR: "Последовательное параллельное соединение"},
    displaySettings: {
      ID: 1625,
      CN: "显示设置",
      TR: "Дополнительные настройки",
    },
    curveExport: { ID: 2375, CN: "曲线导出", TR: "Экспорт кривой" },
    chartColor: { ID: 2376, CN: "图表颜色", TR: "Цвет диаграммы" },
    monochrome: { ID: 139, CN: "单色", TR: "Черно-белый режим" },
    multicolour: { ID: "", CN: "彩色", TR: "Цветовой" },
    spectrumDisplay: { ID: 2377, CN: "型谱显示", TR: "Отображение спектра" },
    display: { ID: 217, CN: "显示", TR: "Отобразить" },
    display_curve: {
      ID: "",
      CN: "显示在曲线末端",
      TR: "Показать в конце кривой",
    },
    displayPanel: {
      ID: "",
      CN: "显示在面板",
      TR: "Показать на панели",
    },
    noDisplay: { ID: 158, CN: "不显示", TR: "Не отображать" },
    onlyShowworkCurve: {
      ID: 1969,
      CN: "仅显示工作曲线",
      TR: "Показывать только рабочую кривую",
    },
    speedList: { ID: 2378, CN: "速度列表", TR: "Список скоростей" },
    addSpeed: { ID: 2379, CN: "添加速度", TR: "Прибавьте скорости" },
    addPinLv: { ID: 2379,CN:"添加频率", TR: "Добавить частоту" },
    pleaseEnterSpeed: {
      ID: 1154,
      CN: "请输入转速",
      TR: "Пожалуйста введите скорость",
    },
    pleaseEnterHz: {
      ID: "",
      CN: "请输入频率",
      TR: "Пожалуйста, введите частоту ",
    },

    tip: { ID: 286, CN: "提示", TR: "Подсказка" },
    define: { ID: 125, CN: "确定", TR: "ОК" },
    cancel: { ID: 126, CN: "取消", TR: "Отмена" },
    download: { ID: 448, CN: "下载", TR: "Скачать" },
    downloadTips: {
      ID: "",
      CN: "请下载桌面程序,导出性能曲线",
      TR: "Загрузите рабочий стол, чтобы экспортировать свойства",
    },
    curve: { ID: 766, CN: "曲线图", TR: "Диаграмма" },
    document: { ID: 984, CN: "文档", TR: "Документация" },
    DocumentNone: { ID: "", CN: "文档(无)", TR: "Документация (отсутствует)" },
    Model: { ID: 2137, CN: "模型", TR: "Тип" },
    queryPoint: { ID: "", CN: "查询点", TR: "точка запроса" },
    productNoSelect: { ID: "", CN: "产品编号选择", TR: "нумерация продуктов" },
    watermark: { ID: "", CN: "水印", TR: "Водяной знак" },
    IsPrintModel3d: {
      ID: "",
      CN: "产生三维页面",
      TR: "Создается ли трехмерная страница",
    },
    IsCreateMultiSpeedChart: {
      ID: "",
      CN: "产生变频曲线",
      TR: "Создается ли кривая преобразования частоты",
    },
    queryCurve: { ID: 125, CN: "查询曲线", TR: "Запрос графика" }, //yy  add---
    parameterQuery: { ID: 1575, CN: "参数查询", TR: "Запрос параметров" },
    parameter_s: { ID: "", CN: "参数", TR: "Параметры" },
    parameterCancel: { ID: 122, CN: "取消", TR: "Отмена" },
    parameterDetermine: { ID: 121, CN: "确定", TR: "ОК" },
    showDesignPoints: {
      ID: 210,
      CN: "显示设计点",
      TR: "Отобразить расчетную точку",
    },
    designPointStyle: { ID: "", CN: "设计点样式", TR: "Дизайн точек" },
    crosshair: { ID: 1453, CN: "十字线", TR: "Крестовая линия" },
    invertedTriangle: {
      ID: 1826,
      CN: "倒三角",
      TR: "Перевернутый треугольник",
    },
    roundDot: { ID: "", CN: "圆点", TR: "Точка" },
    boldRightAngle: { ID: "", CN: "加粗直角", TR: "Прямой угол утолщения" },
    deviceCurve: { ID: "", CN: "装置曲线", TR: "Системная кривая" },
    displayIndex: { ID: 212, CN: "显示", TR: "Отобразить" },
    netHeadValue: { ID: "", CN: "净扬程值", TR: "Чистый напор" },
    displayCurve: { ID: 400, CN: "显示曲线", TR: "Отобразить кривую" },
    onlyDisplayCurve: {
      ID: 1303,
      CN: "仅显示工作曲线",
      TR: "Показывать только рабочую кривую",
    },
    showAllCurves: { ID: "", CN: "显示所有曲线", TR: "Показать все кривые" },
    outputChartToCAD: {
      ID: "",
      CN: "请下载客户端，客户端才能导出CAD格式文件",
      TR: "Загрузите клиент, чтобы экспортировать файл в формате CAD",
    },
    inquiry: { ID: 2264, CN: "询价", TR: "Запрос цены" },
    productInquiry: { ID: 39, CN: "产品询价", TR: "Запрос стоимости" },
    address: { ID: 191, CN: "地址", TR: "Адрес" },
    contactName: { ID: "", CN: "联系人名称", TR: "Имя контакта" },
    pumpModel: { ID: 751, CN: "泵型号", TR: "Модель насоса" },
    pumpNumber: { ID: 451, CN: "泵数量", TR: "Количество насосов" },
    submit: { ID: 407, CN: "提交", TR: "Отправить" },
    inquirtFormatte1: {
      ID: "",
      CN: "请输入联系方式",
      TR: "Введите контактные данные",
    },
    inquirtFormatte2: {
      ID: "",
      CN: "请输入联系人名称",
      TR: "Введите имя контакта",
    },
    selectMedia: {
      ID: "",
      CN: "选择介质",
      TR: "Выберите носитель",
    }, //yy add
    cleanWater: {
      ID: 459,
      CN: "清水",
      TR: "Чистая вода",
    },
    viewDetail: {
      ID: 661,
      CN: "查看详情",
      TR: "Посмотреть подробности",
    },
    sewage: {
      ID: 21,
      CN: "污水",
      TR: "Сточные водые",
    },
    viscousSlurry: {
      ID: "",
      CN: "污水、渣浆粘稠浆液",
      TR: "сточные воды, шлаковый раствор",
    },
    chemicalLiquid: {
      ID: "",
      CN: "化学液体",
      TR: "Химическая жидкость",
    },
    hydrocarbons: {
      ID: "",
      CN: "化学液体、烃类等",
      TR: "Химические жидкости, углеводороды и т.д",
    },
    Gas: {
      ID: "",
      CN: "气体",
      TR: "Газ",
    },
    gasList: {
      ID: "",
      CN: "空气、油气、瓦斯",
      TR: "Воздух, нефть и газ, газ",
    },
    nameplateParameter: {
      ID: 2194,
      CN: "铭牌参数",
      TR: "Параметры заводской таблички",
    },
    angle: { ID: 1500, CN: "角度", TR: "Угол" },
    printCompanyInfo: {
      ID: "",
      CN: "打印公司信息",
      TR: "Печать информации о компании",
    },
    auto: { ID: "", CN: "自动判断", TR: "Автоматический" },
    original: { ID: "", CN: "原始方向", TR: "Первоначальный" },
    clockwise: { ID: "", CN: "顺时针方向", TR: "По часовой стрелке" },
    counterclockwise: { ID: "", CN: "逆时针方向", TR: "Против часовой стрелки" },

    resize:{ID:"",TR:"Изменить размер"},
    zoomIn:{ID:"",TR:"Увеличить"},
    zoomOut:{ID:"",TR:"Уменьшить"},
    highlightModifyArea:{ID:"",TR:"Изменить область подсветки"},
    move:{ID:"",TR:"Переместить"},

    productConfig:{ID:"",CN:"产品配置",TR:"Настройка продукции"},
    exportSettings:{ID:"",CN:"导出设置",TR:"Параметры экспорта"},
    path:{ ID: "", CN:"路径", TR:"Путь" },
    monochromeDisplay:{ ID: "", CN:"单色显示", TR:"Монохромное отображение" },
    chartSettings:{ ID: "", CN:"图表设置", TR:"Параметры диаграммы" },
    selectionPoint:{ ID: "", CN:"选型点", TR:"Точка выбора" },
    nameplateParameterPoints:{ ID: "", CN:"铭牌参数点", TR:"Параметры таблички" },
    operatingArea:{ ID: "", CN:"运行区域", TR:"Область действия" },
    optimalArea:{ ID: "", CN:"最优区域", TR:"Оптимальная область" },
    deviceArea:{ ID: "", CN:"装置区域", TR:"Область установки" },
    flowHeadLine:{ ID: "", CN:"流量扬程线", TR:"линия напора потока" },
    allHeadCurves:{ ID: "", CN:"所有扬程曲线", TR:"Все кривые напора" },
    flowEfficiencyLine:{ ID: "", CN:"流量效率线", TR:"Линия эффективности потока" },
    onlyWorkingCurve:{ ID: "", CN:"仅工作曲线", TR:"Только рабочая кривая" },
    flowPowerLine: { ID: "", CN:"流量功率线", TR:"линия мощности потока" },
    AllPowerCurves:{ ID: "", CN:"所有功率曲线", TR:"Все кривые мощности" },
    textContent:{ ID: "", CN:"文本内容", TR:"Содержание текста" },
    rotationAngle:{ ID: "", CN:"旋转角度", TR:"Угол вращения" },
    fontSize:{ ID: "", CN:"文字大小", TR:"Размер текста" },
    alignmentMethod:{ ID: "", CN:"对齐方式", TR:"Выравнивание" },
    fontColor:{ ID: "", CN:"文字颜色", TR:"Цвет текста" },
    blod:{ ID: "", CN:"加粗", TR:"Толщина" },
    italic:{ ID: "", CN:"倾斜", TR:"Наклонение" },
    leftRotation:{ ID: "", CN:"左旋转", TR:"Повернуть влево" },
    rightRotation:{ ID: "", CN:"右旋转", TR:"Повернуть вправо" },
    equivalentLine:{ ID: "", CN:"等效线", TR:"Эквивалентная линия" },
    minFlowCurve: { ID: "", CN: "最小连续流量线",TR:"кривая минимального расхода" },
    maximumEfficiencyPoint: { ID: "", CN: "高效点",TR:"Точка максимальной эффективности" },
    allCurves:{ ID: "", CN:"所有曲线", TR:"Все кривые" },
    flowNPSHrCurve:{ ID: "", CN:"流量汽蚀线", TR:"Кривая NPSHr"},
    colorStyle:{ID: "", CN:"颜色样式", TR:"Цветовой стиль"},
    maxMinWorkingCurve: { ID: "", CN: "最大最小工作曲线",TR:"Максимально - минимальная рабочая кривая" },
    errorTip: { ID: "", CN: "不能小于最小轴功率",TR:"Не может быть меньше минимальной мощности оси"},

    addCurve: { ID: "",CN:'添加曲线', TR: "Добавить кривую"},
    addFlowPoint: { ID: "", CN: "添加流量点", TR: "Добавить точку трафика"},
    byFrequency: { ID: "", CN: "按频率", TR: "По частоте"},
    bySpeed: { ID: "", CN: "按转速", TR: "По обороту"},
    byOperatingPoint: { ID: "", CN: "按运行点", TR: "Нажмите точку запуска"},
    queryInfo: { ID: "", CN: "查询信息", TR: "Информация о запросе"},
    pointName: { ID: "", CN: "点名", TR: "Перекличка"},
  },
  //报表分析
  LCC: {
    Analysis: { ID: 568, CN: "分析", TR: "Анализ" },
    accumulationCurve: {
      ID: 927,
      CN: "年度累计曲线",
      TR: "Годовая кривая накопления",
    },
    statisticalChart: {
      ID: 928,
      CN: "单年统计图",
      TR: "Статистический показатель за один год",
    },
    workingPointFlow: { ID: 554, CN: "工作点流量", TR: "Расход рабочей точки" },
    default: { ID: 921, CN: "默认", TR: "По умолчанию" },
    heating: { ID: 922, CN: "供暖", TR: "Теплоснабжение" },
    pressurize: { ID: 923, CN: "增压", TR: "Усилитель" },
    custom: { ID: 924, CN: "自定义", TR: "Настройки пользователя" },
    status: { ID: 851, CN: "状态", TR: "Состояние" },
    flowRatio: { ID: 932, CN: "流量比例", TR: "Процент расхода" },
    timeScale: { ID: 933, CN: "时间比例", TR: "Процент времени" },
    fullLoad: { ID: 934, CN: "全负荷", TR: "Полная загрузка" },
    partialLoad: { ID: 936, CN: "部分负荷", TR: "Загрузка детали" },
    nightCoolingOperation: {
      ID: 938,
      CN: "夜间降温运行",
      TR: "Охлаждение в ночное время",
    },
    lowLoad: { ID: 937, CN: "低负荷", TR: "Низкая скорость загрузки" },
    load: { ID: 2381, CN: "负荷", TR: "Загрузить" },
    energyCosts: {
      ID: 560,
      CN: "能耗成本",
      TR: "Стоимость потребления энергии",
    },
    workingDays: {
      ID: 555,
      CN: "每年大致工作天数",
      TR: "Примерное количество рабочих дней в году",
    },
    workingHours: {
      ID: 556,
      CN: "每年大致工作小时",
      TR: "Примерное количество рабочих часов в день",
    },
    powerFees: { ID: 566, CN: "电费", TR: "Плата за электричество" },
    per: { ID: 564, CN: "每度", TR: "Каждый киловатт-час" },
    risiPowerPrice: { ID: 2382, CN: "电费上涨", TR: "Цена электроэнергии" },
    eachYear: { ID: 565, CN: "每年", TR: "Ежегодно" },
    CalcCycle: { ID: 557, CN: "计算周期", TR: "Расчетный период" },
    year: { ID: 558, CN: "年", TR: "Год" },
    interestRate: { ID: 559, CN: "利率", TR: "Процентная ставка" },
    droop: { ID: 567, CN: "效率下降", TR: "Снижение КПД системы" },
    co2Ratio: { ID: 920, CN: "CO2系数", TR: "Коэффициент CO2" },
    conversionFactor: {
      ID: 2427,
      CN: "煤炭折算系数",
      TR: "Коэффициент пересчёта",
    }, //!!!!!
    maintenanceCost: {
      ID: 535,
      CN: "维护维修成本",
      TR: "Стоимость технического обслуживания",
    },
    thousand: { ID: 2383, CN: "千元", TR: "Тысяча Юаней" },
    maintenance: {
      ID: 2384,
      CN: "维护和维修",
      TR: "Техническое обслуживание и ремонт",
    },
    runningCost: { ID: 541, CN: "运行费用", TR: "Эксплуатационные расходы" },
    downtimeAndLoss: {
      ID: 539,
      CN: "生产停工和损耗",
      TR: "Время простоя и потери производства",
    },
    environmentalFee: {
      ID: 540,
      CN: "环境保护费",
      TR: "Стоимость охраны окружающей среды",
    },
    othersFee: { ID: 777, CN: "其他年费用", TR: "Другие годовые сборы" },
    orderCost: { ID: 2385, CN: "设备采购费用", TR: "Стоимость заказа" },
    installDebugCharge: { ID: 550, CN: "安装和调试", TR: "Монтаж и наладка" },
    tonAndkW: { ID: 2386, CN: "吨/万千瓦", TR: "Тонн / 10000 Вт" },
    mapOfCosts: { ID: 925, CN: "费用图", TR: "Таблица затрат" },
    costItem: { ID: 929, CN: "费用项", TR: "Статья расходов" },
    cost: { ID: 930, CN: "费用", TR: "Стоимость" },
    percentage: { ID: 931, CN: "百分比", TR: "Процент" },
    initialCost: { ID: 655, CN: "初期成本", TR: "Начальная стоимость" },
    maintenanceAndRepair: {
      ID: 542,
      CN: "维修和护理",
      TR: "Техническое обслуживание и ремонт",
    },
    co2: { ID: 906, CN: "CO2", TR: "CO2" },
    coalConsumption: { ID: 2388, CN: "煤耗量", TR: "Потребление угля" },
    totalAnnualCost: { ID: 958, CN: "年总费用", TR: "Общая годовая стоимость" },
    co2TotalEmissions: {
      ID: 2389,
      CN: "co2总排放量",
      TR: "Общий объем выбросов CO2",
    },
    tenThousand: { ID: 940, CN: "万", TR: "Десять тысяч" },
    tenThousandTon: { ID: 2390, CN: "万吨", TR: "Десять тысяч" },

    calculationPeriod: {
      ID: "",
      CN: "请输入计算周期",
      TR: "Введите цикл вычислений",
    }, //yy ---add
    scaleTime: {
      ID: "",
      CN: "请输入时间比例!",
      TR: "Введите соотношение времени!",
    },
    sumProportions: {
      ID: "",
      CN: "请输入时间比例之和为100%!",
      TR: "Введите сумму соотношения времени 100%!",
    },
    electricCharge: {
      ID: "",
      CN: "请输入电费(每度)!",
      TR: "Введите плату за электричество (каждый градус)!",
    },
    coefficient_c: {
      ID: "",
      CN: "请输CO2系数!",
      TR: "Пожалуйста, потеряйте коэффициент CO2!",
    },
    conversionCoefficient: {
      ID: "",
      CN: "请输入煤炭折算系数!",
      TR: "Пожалуйста, введите коэффициент пересчета угля!",
    },
  },
  //首页
  indexPage: {
    corpIntroduction: { ID: 30, CN: "公司介绍", TR: "Информация о компании" },
    basicInformation: { ID: 2140, CN: "基础信息", TR: "Основная информация" },
    enterpriseHonors: { ID: 32, CN: "企业荣誉", TR: "Достижения компании" },
    enterpriseStyle: { ID: 2286, CN: "企业风貌", TR: "Фирменный стиль" },
    organizationStructure: {
      ID: "",
      CN: "组织结构",
      TR: "Структура организации",
    },
    corporateCulture: { ID: "", CN: "企业文化", TR: "Культура предприятия" },
    introductionToPumpAnimation: {
      ID: "",
      CN: "泵型动画介绍",
      TR: "Описание модели насоса с помощью мультипликации",
    },
    companyPortfolio: { ID: "", CN: "公式组合", TR: "Комбинация формулы" },
    salesNetwork: { ID: 31, CN: "销售网络", TR: "Сеть продаж" },
    performanceSelection: {
      ID: 2287,
      CN: "水力性能选型",
      TR: "Выбор гидравлических характеристик",
    },
    productSearch: { ID: 771, CN: "产品搜索", TR: "Поиск продукта" },
    contactinformation: { ID: 35, CN: "联系方式", TR: "Контактная информация" },
    myProject: { ID: 1716, CN: "我的项目", TR: "мой проект" },
    ebook: { ID: 1, CN: "电子样本", TR: "Электронный каталог" },
    pdfFile: { ID: 1717, CN: "纸质样本", TR: "Pdf файл" },
    application: { ID: 2391, CN: "行业应用", TR: "Промышленное применение" },
    intelligentSelection: { ID: 68, CN: "智能选型", TR: "Умный выбор" },
    firePump: { ID: 2289, CN: "消防泵", TR: "Пожарный насос" },
    flow: { ID: 47, CN: "流量", TR: "Расход" },
    head: { ID: 48, CN: "扬程", TR: "Напор" },
    type: { ID: 246, CN: "类型", TR: "Тип" },
    more: { ID: 734, CN: "更多", TR: "Больше" },
    nextStep: { ID: 368, CN: "下一步", TR: "Следующий шаг" },
    zmSearch: { ID: 2392, CN: "按字母查找", TR: "Выбор по алфавиту" },
    alphaList: { ID: "", CN: "字母列表", TR: "Список буквы" },
    byType: { ID: 2337, CN: "按类型", TR: "По типу" },
    byIndustry: { ID: 2338, CN: "按行业", TR: "По областям" },
    product: { ID: 721, CN: "产品", TR: "продукт" },
    material: { ID: 722, CN: "资料", TR: "Данные" },
    byProductLine: { ID: "", CN: "按产品线", TR: "По типу насоса" },
    model_3D: { ID: 132, CN: "BIM模型", TR: "модель BIM" },
    about_us: { ID: 2393, CN: "关于我们", TR: "о нас" },
    product_catalog: { ID: 2394, CN: "产品目录", TR: "Каталог продукции" },
    product_selection: { ID: 2395, CN: "产品选型", TR: "Выбор продукта" },
    letter_search: { ID: 2396, CN: "字母搜索", TR: "Поиск писем" },
    application_HY: { ID: 2391, CN: "行业应用", TR: "Промышленное применение" },
    application_area: { ID: 2339, CN: "应用领域", TR: "Область применения" },
    sample_Model: { ID: 2397, CN: "样本模型", TR: "Примерная модель" },
    corpInfo: { ID: 1802, CN: "公司信息", TR: "Информация о компании" },
    searchByPumpImg: {
      ID: "",
      CN: "按产品图搜索",
      TR: "Поиск по товарной карте",
    },
    pleaseSelect: { ID: 2022, CN: "请选择", TR: "Пожалуйста выберите" },
    corpInfo: { ID: 1802, CN: "公司信息", TR: "Информация о компании" },
    enterpriseVision: { ID: "", CN: "企业愿景", TR: "видение предприятия" },
    coreValues: { ID: "", CN: "核心价值观", TR: "основные ценности" },
    managementIdea: { ID: "", CN: "经营理念", TR: "концепция хозяйствования" },
    productSeries: { ID: 2320, CN: "产品系列", TR: "Серия продукта" },
    enterpriseInformation: {
      ID: "",
      CN: "企业信息",
      TR: "Информация о предприятии",
    },
    pipelineLoss: { ID: 325, CN: "管路损失", TR: "Потери трубопровода" },
    clearCache: { ID: "", CN: "清除缓存", TR: "Очистить кэш" },
    myCollection: { ID: 308, CN: "我的收藏", TR: "Избранное" },
    compareList: { ID: 840, CN: "比较列表", TR: "Сравнить список" },
    lang: { ID: 449, CN: "语言", TR: "Язык" },
    cn: { ID: 714, CN: "中文", TR: "Китайский" },
    en: { ID: 296, CN: "英文", TR: "Английский" },
    about: { ID: 2598, CN: "关于", TR: "О" },
    developers: { ID: 40, CN: "软件开发商", TR: "Разработчики" },
    privacyStatement: {
      ID: "",
      CN: "隐私声明",
      TR: "конфиденциальное заявление",
    },
    userAgreement: { ID: "", CN: "用户协议", TR: "Протокол пользователя" },
    changePassword: { ID: 23, CN: "修改密码", TR: "Изменить пароль" },
    LogOut: { ID: 707, CN: "退出登录", TR: "выход" },
    currentVersion: { ID: 1492, CN: "当前版本", TR: "Текущая версия" },
    top: { ID: 1901, CN: "顶部", TR: "Верхний" },
    add: { ID: 710, CN: "公司地址", TR: "Адрес компании:" },
    tel: { ID: 2398, CN: "联系电话", TR: "Контактный номер:" },
    email: { ID: 2399, CN: "企业邮箱", TR: "E-mail:" },
    hotline: {
      ID: 2400,
      CN: "全国同一服务热线",
      TR: "Горячая линия национальной службы:",
    },
    helpManual: { ID: "", CN: "帮助手册", TR: "Руководство по справке" },
    viewNow: { ID: 170, CN: "立即查看", TR: "немедленный осмотр" },
    quick: { ID: "", CN: "快速", TR: "быстрый" },
    sampleBook: { ID: "", CN: "产品样本", TR: "образец продукции" },
    simpleAndDirect: { ID: "", CN: "清晰简捷", TR: "чёткий и быстрый" },
    clearClassification: { ID: "", CN: "分类明确", TR: "Категоризация" },
    quickProductSelection: {
      ID: "",
      CN: "产品快速选取",
      TR: "быстрая выборка продукции",
    },
    productSamplePreview: {
      ID: "",
      CN: "产品样本预览",
      TR: "предварительный просмотр",
    },
    productNameAtoZ: {
      ID: "",
      CN: "产品名称A-Z",
      TR: "название продукта A - Z",
    },
    findApplications: {
      ID: "",
      CN: "发现适合您需求的应用",
      TR: "найти приложение",
    },
    feedBack: { ID: "", CN: "问题反馈", TR: "Обратная связь" },
    feedbackContent: {
      ID: "",
      CN: "反馈内容",
      TR: "Содержание обратной связи",
    },
    feedbackRule: {
      ID: "",
      CN: "联系人或联系方式不能为空",
      TR: "Контакты или контактные данные не могут быть пустыми!!",
    },
    problemType: { ID: "", CN: "问题类型", TR: "Тип вопроса" },
    rorExample: {
      ID: "",
      CN: "例如：软件问题、曲线错误",
      TR: "Например: проблемы с программным обеспечением, ошибки кривой",
    },
    classAndSelection: { ID: "", CN: "分类选型", TR: "Классификация" },
    industrySelection: { ID: "", CN: "行业选型", TR: "Выбор профессии" },
    projectList: { ID: "", CN: "项目列表", TR: "Список проектов" },
    customerList: { ID: "", CN: "客户列表", TR: "Список клиентов" },

    marketSector: { ID: "", CN: "市场领域", TR: "Сфера рынка" },
    alphabeticSort: { ID: "", CN: "字母排序", TR: "Список буквы" },
    intelligentSelectionSub: {
      ID: "",
      CN: "根据参数筛选，精准选出所需的型号",
      TR: "Отбор по параметрам, точный выбор нужной модели",
    },
    marketSectorSub: {
      ID: "",
      CN: "根据设备应用领域，呈现所需的型号",
      TR: "Показывать нужные модели в зависимости от области применения оборудования",
    },
    alphabeticSortSub: {
      ID: "",
      CN: "根据字母排序，罗列所有的设备系列",
      TR: "Перечислите все серии устройств в алфавитном порядке",
    },
    enterSelect: { ID: "", CN: "进入选型", TR: "Выбор" },
    companyWebsite: { ID: "", CN: "企业官网", TR: "Веб-сайт компании" },
  },
  //管路计算
  pipeLoss: {
    back: { ID: "", CN: "返回", TR: "Возвращение" },
    selparas: { ID: 5, CN: "参数选型", TR: "Подбор по точке" },
    previous: { ID: 367, CN: "上一步", TR: "Предыдущий шаг" },
    nextStep: { ID: 368, CN: "下一步", TR: "Следующий шаг" },
    flowRule: { ID: 2143, CN: "请输入流量", TR: "Пожалуйста   введите расход" },
    flow: { ID: 47, CN: "流量", TR: "Расход" },
    head: { ID: 48, CN: "扬程", TR: "Напор " },
    medium: { ID: 1448, CN: "介质", TR: "Среда" },
    mediaRule: { ID: "", CN: "请输入介质", TR: "Введите диск" },
    selectType: { ID: 2462, CN: "所选类型", TR: "Выберите тип" },
    selectTypeRule: { ID: "", CN: "请选择类型", TR: "Выберите тип" },
    pipeWallThicknessNo: {
      ID: 2541,
      CN: "管壁厚度号",
      TR: "Толщина стенки трубы",
    },
    inletPipe: { ID: "", CN: "进水管", TR: "впускная труба" },
    drainagePipe: { ID: "", CN: "排水管", TR: "водосточная труба" },
    RCOIP: {
      ID: "",
      CN: "进水管阻力系数",
      TR: "коэффициент сопротивления впускной трубы",
    },
    DPRC: {
      ID: "",
      CN: "排水管阻力系数",
      TR: "коэффициент сопротивления дренажной трубы",
    },
    suctionconfig: {
      ID: 2497,
      CN: "吸入配置",
      TR: "Конфигурация всасывающего устройства",
    },
    atmospheric: { ID: 2531, CN: "大气压", TR: "Атмосферное давление" },
    WTSP: {
      ID: 2532,
      CN: "水塔表面压力",
      TR: "Поверхностное давление водонапорной башни",
    },
    waterAbsorptionHeight: { ID: "", CN: "吸水高度", TR: "высота всасывания" },
    PipelineLength: { ID: 2474, CN: "管路长度", TR: "Длина трубопровода" },
    entrance: { ID: 2520, CN: "入口", TR: "Вход" },
    export: { ID: 2521, CN: "出口", TR: "Выход" },
    elbow_90: { ID: 2522, CN: "90°弯头", TR: "Колено под углом 90°" },
    ballValve: { ID: 2523, CN: "球阀", TR: "Шаровой кран" },
    butterflyValve: { ID: 2524, CN: "蝶阀", TR: "Дроссельная заслонка" },
    gateValve: { ID: 2525, CN: "闸阀", TR: "Задвижка" },
    globeValve: { ID: 2526, CN: "截止阀", TR: "Шаровой клапан" },
    plugValve: { ID: 2527, CN: "旋塞阀", TR: "Запорный клапан" },
    liftCheckValve: {
      ID: 2528,
      CN: "升降式止回阀",
      TR: "Подъёмный обратный клапан",
    },
    stopCheckValve: {
      ID: 2529,
      CN: "截止止回阀",
      TR: "Шаровый обратный клапан",
    },
    swingCheckValve: {
      ID: 2530,
      CN: "旋启式止回阀",
      TR: "Поворотный обратный клапан",
    },
    dischargeConfig: { ID: 2498, CN: "排出配置", TR: "Способ разгрузки" },
    staticDischargeHead: {
      ID: 2537,
      CN: "静排出扬程",
      TR: "Статический напор на выходе",
    },
    calcResults: { ID: 2499, CN: "计算结果", TR: "Результаты расчётов" },
    designPoint: { ID: 2538, CN: "设计点", TR: "Проектная точка" },
    pipeSize: { ID: 2547, CN: "管路尺寸", TR: "Размер трубы" },
    localLoss: { ID: 2548, CN: "局部损失", TR: "Местные потери" },
    LATWIP: {
      ID: 2550,
      CN: "进水管路沿程损失",
      TR: "Потери вдоль впускной трубы",
    },
    LATWOP: {
      ID: "",
      CN: "出水管路沿程损失",
      TR: "потеря по длине выходного трубопровода",
    },
    FCOIP: {
      ID: 2549,
      CN: "进水管路摩擦系数",
      TR: "Коэффициент трения впускной трубы",
    },
    FCOOP: {
      ID: "",
      CN: "出水管路摩擦系数",
      TR: "коэффициент трения выходного трубопровода",
    },
    pipe: { ID: 2551, CN: "管路", TR: "Трубопроводный" },
    materialsAndStandards: {
      ID: 2540,
      CN: "材料及标准",
      TR: "Материалы и стандарты",
    },
    withSuctionHead: { ID: "", CN: "有吸水扬程", TR: "напор всасываемой воды" },
    suctionSystem: { ID: "", CN: "抽吸系统", TR: "система всасывания" },
    divingSystem: { ID: "", CN: "潜水系统", TR: "водолазный система" },
    circulatorySystem: { ID: "", CN: "循环系统", TR: "циркуляционная система" },
    simpleCalculation: { ID: "", CN: "简易计算", TR: "Простой расчет" },
    liquidHeight: { ID: "", CN: "液面高度", TR: "высота уровня" },
    fluidName: { ID: "", CN: "流体名称", TR: "наименование жидкости" },
    pipeDiameter: { ID: "", CN: "管道直径", TR: "диаметр трубопровода" },
    totalPipeLength: { ID: "", CN: "管道总长", TR: "длина трубопровода" },
    viscosity: { ID: 205, CN: "粘度", TR: "вязкость" },
    proportion: { ID: "", CN: "比重", TR: "удельный вес" },
    altitude: { ID: "", CN: "高程", TR: "высота" },
    pressureDrop: {
      ID: "",
      CN: "计算压力降为",
      TR: "расчетный перепад давления",
    },
    calc: { ID: 333, CN: "计算", TR: "Расчет" },
    bend_90: { ID: "", CN: "90°弯管", TR: "колено под углом 90°" },
    bend_45: { ID: "", CN: "45°弯管", TR: "колено под углом 45°" },
    threeWayBranches: { ID: "", CN: "三通分流数", TR: "тройная составляющая" },
    numberOfTeeLines: { ID: "", CN: "三通线流数", TR: "трехходовой поток" },
    angleValves: { ID: "", CN: "角阀", TR: "угловой клапан" },
    checkValve: { ID: "", CN: "止回阀", TR: "обратный клапан" },
    pcs: { ID: "", CN: "只", TR: "PCS" },
    returnPipe: { ID: "", CN: "回水管", TR: "обратная труба" },
    load: { ID: "", CN: "载荷", TR: "нагрузка" },
    staticSuctionHead: {
      ID: 2533,
      CN: "静吸入扬程",
      TR: "Статический напор на на входе",
    },
    stbmylRule: {
      ID: 2574,
      CN: "请输入水塔表面压力",
      TR: "Пожалуйста введите поверхностное давление водонапорной башни",
    },
    xsgdRule: {
      ID: 2577,
      CN: "请输入吸水高度",
      TR: "Пожалуйста введите высоту всасывания",
    },
    pipeLength: {
      ID: 2584,
      CN: "请输入管路长度",
      TR: "Пожалуйста введите длину трубопровода",
    },
  },
  simpleLoginPage: {
    login: { ID: 673, CN: "登录", TR: "Войти в систему" },
    register: { ID: 380, CN: "注册", TR: "Регистрация" },
    enterVerificCode: {
      ID: 2401,
      CN: "请输入验证码",
      TR: "Пожалуйста введите проверочный код",
    },
    verificCodeError: {
      ID: 2402,
      CN: "验证码错误",
      TR: "Ошибка проверочного кода",
    },
    loginPrompt: {
      ID: 2403,
      CN: "登录提示",
      TR: "Приглашение для входа в систему",
    },
    passwordError: { ID: 400, CN: "密码错误", TR: "Неправильный пароль" },
    loginSuccessful: {
      ID: 2404,
      CN: "登录成功,正在跳转~",
      TR: "Регистрация успешно, прыжок~",
    },
    AccountLogin: { ID: 2405, CN: "账户登录", TR: "Вход в учетную запись" },
    CodeScanningLogin: {
      ID: 2290,
      CN: "扫码登录",
      TR: "Сканируйте код для входа в систему",
    },
    registerInfo: {
      ID: 2291,
      CN: "如果您还没有加入我们，可以点击下方的注册成为我们的一员",
      TR: "Если вы еще не присоединились к нам  вы можете нажать кнопку зарегистрироваться ниже  чтобы стать одним из нас",
    },
    registerInfoTitle: { ID: 2292, CN: "新用户", TR: "Новый пользователь" },
    loginInfo: {
      ID: 2293,
      CN: "如果您已经是我们中的一员可以点击下方的登录，进入到我们的平台",
      TR: "Если вы уже являетесь одним из нас  вы можете нажать на кнопку ниже  чтобы войти на нашу платформу",
    },
    loginInfoTitle: { ID: 2294, CN: "我们中的一员", TR: "Один из нас" },
    userType: { ID: 2295, CN: "用户类型", TR: "Тип пользователя" },
    loginName: { ID: 2296, CN: "账户名", TR: "Имя учётной записи" },
    password: { ID: 378, CN: "密码", TR: "Пароль" },
    userType0: { ID: 703, CN: "内部人员", TR: "Внутренний персонал" },
    userType1: { ID: 2297, CN: "外部人员", TR: "Внешний персонал" },
    userType2: { ID: "", CN: "代理商", TR: "Агенты" },
    phoneNumber: { ID: 379, CN: "手机号", TR: "Мобильный номер" },
    email: { ID: 1803, CN: "邮箱", TR: "Электоронная почта" },
    forgetPassword: { ID: "", CN: "忘记密码", TR: "Забыли пароль" },
    sendSuccess: { ID: "", CN: "发送成功", TR: "Отправка выполнена" },
    verifyAccount: { ID: "", CN: "账号验证", TR: "Утвердить аккаунт" },
    fillInInformation: { ID: "", CN: "填写信息", TR: "Заполнить информацию" },
    registerSuccess: {
      ID: 890,
      CN: "注册成功",
      TR: "Вы успешно зарегистрировались",
    },
    registerTips: {
      ID: "",
      CN: "请填写您注册时的手机号",
      TR: "Пожалуйста, заполните номер телефона при регистрации",
    },
    forgetEmailTips: {
      ID: "",
      CN: "请填写您注册时的邮箱",
      TR: "Пожалуйста, заполните почтовый ящик при регистрации.",
    },
    verifyCode: { ID: 700, CN: "验证码", TR: "Код подтверждения" },
    send: { ID: "", CN: "发送", TR: "Отправление" },
    userAccount: { ID: "", CN: "用户账号", TR: "номер счета пользователя" },
    oldPassword: { ID: "", CN: "旧密码", TR: "Старый пароль" },
    oldPsdTips: { ID: "", CN: "请输入旧密码", TR: "Ввести старый пароль" },
    newPassword: { ID: 397, CN: "新密码", TR: "Новый пароль" },
    newPsdTips: { ID: "", CN: "请输入新密码", TR: "Ввести новый пароль" },
    oldPwdRule: {
      ID: "",
      CN: "旧密码不能为空",
      TR: "Старый пароль не может быть пустым",
    },
    newPwdRule: {
      ID: "",
      CN: "新密码不能为空",
      TR: "Новый пароль не может быть пустым",
    },
    oldAndNewPwdRule: {
      ID: "",
      CN: "新旧密码不能一致",
      TR: "Новый пароль и старый пароль не совпадают",
    },
    enterPwdAgain: {
      ID: 2303,
      CN: "请再次输入密码",
      TR: "Пожалуйста введите пароль еще раз",
    },
    enterTwoPwdDisaccord: {
      ID: "",
      CN: "两次输入密码不一致",
      TR: "Введенные дважды пароли не совпадают",
    },
    changeSuccess: { ID: 636, CN: "修改成功", TR: "Успех модификации" },
    pwdRule: { ID: 399, CN: "密码不一致", TR: "Пароли не совпадают" },
    accountSettings: { ID: "", CN: "账号设置", TR: "Настройка аккаунта" },
    confirmPassword: { ID: "", CN: "确定密码", TR: "Утвердить пароль" },
    realName: { ID: "", CN: "用户名", TR: "Наименование Пользователя" },
    corpName: { ID: 102, CN: "公司名称", TR: "Название компании" },
    corpAddress: { ID: 710, CN: "公司地址", TR: "Адрес компании" },
    welcomeLogin: {
      ID: "",
      CN: "注册成功，欢迎登录",
      TR: "регистрация прошла успешно.",
    },
    returnLogin: { ID: "", CN: "返回登录", TR: "обратный вход" },
    accountDeteld: { ID: "", CN: "账户注销", TR: "Списание счетов" },
    formValidate: {
      email0: { ID: 773, CN: "请输入邮箱", TR: "Введите почтовый ящик" },
      email1: {
        ID: 2298,
        CN: "请输入正确的邮箱格式",
        TR: "Введите правильный формат почтового ящика",
      },
      TelPhone0: {
        ID: 2299,
        CN: "请输入手机号码",
        TR: "Введите номер телефона",
      },
      TelPhone1: {
        ID: 2300,
        CN: "请输入正确的手机号码格式",
        TR: "Введите правильный номер телефона",
      },
      pass0: { ID: 2301, CN: "请输入密码", TR: "Введите пароль" },
      pass1: {
        ID: 2302,
        CN: "请输入密码长度为6~18位",
        TR: "Введите длину пароля на 6 - 18 битов",
      },
      pass2: { ID: 2303, CN: "请再次输入密码", TR: "Повторите пароль" },
      pass3: { ID: 2304, CN: "两次密码输入不一样", TR: "двоичный ввод пароля" },
      pass4: {
        ID: "",
        CN: "密码必须包含大写或小写字母、数字、特殊字符",
        TR: "Пароль должен содержать прописные или прописные буквы, цифры, специальные символы.",
      },
      loginName0: {
        ID: 2305,
        CN: "请输入登录名",
        TR: "Введите имя пользователя",
      },
      loginName1: {
        ID: 2306,
        CN: "请输入登录名长度为6~18位",
        TR: "Введите имя пользователя в длину от 6 до 18 бит",
      },
      userName0: {
        ID: 2307,
        CN: "请输入用户姓名",
        TR: "Введите имя пользователя",
      },
      corpName0: {
        ID: 2307,
        CN: "请输入公司名称",
        TR: "Введите название компании",
      },
      corpAddress0: {
        ID: "",
        CN: "请输入公司地址",
        TR: "Введите адрес компании",
      },
      tips1: {
        ID: "",
        CN: "不能包含特殊符号'或（）或*",
        TR: 'Не может содержать специальные символы "или () или *',
      },
    },
  },
  // 头部header栏
  header: {
    serieslist: { ID: 1, CN: "电子样本", TR: "Электронный каталог" },
    selparas: { ID: 5, CN: "参数选型", TR: "Подбор по точке" },
    lang: { ID: 449, CN: "语言", TR: "язык" },
    cn: { ID: 714, CN: "中文", TR: "Китайский" },
    en: { ID: 296, CN: "英文", TR: "Английский" },
    ko: { ID: 299, CN: "韩文", TR: "Корейский" },
    es: { ID: 2360, CN: "西班牙文", TR: "Испанский" },
    russian: { ID: 302, CN: "俄文", TR: "Русский" },
    Applications: { ID: 2309, CN: "其他应用", TR: "Другие области применения" },
    danji: { ID: 2310, CN: "单机版", TR: "Автономная версия" },
    android: { ID: 2311, CN: "安卓", TR: "Android" },
    ios: { ID: 2312, CN: "苹果", TR: "IOS" },
    wechat: { ID: 2313, CN: "微信", TR: "WeChat" },
    userInfo: { ID: 2423, CN: "账户信息", TR: "Информация учетной записи" },
    logout: { ID: 707, CN: "退出登录", TR: "Выход" },
    collectList: { ID: 2406, CN: "收藏列表", TR: "коллекция" },
    compareList: { ID: 840, CN: "比较列表", TR: "Список избранного" },
    collect: { ID: 1705, CN: "收藏", TR: "избранное" },
    addCollect: { ID: 2407, CN: "加入收藏", TR: "Добавить в избранное" },
    deleteCollect: { ID: 842, CN: "清除收藏", TR: "Очистить избранное" },
    compare: { ID: 691, CN: "比较", TR: "Сравнение" },
    addCompare: { ID: 839, CN: "加入比较", TR: "Добавить к сравнению" },
    deleteCompare: { ID: 841, CN: "清除比较", TR: "Точное сравнение" },
    comparisonAdded: {
      ID: 2408,
      CN: "已经加入比较列表",
      TR: "Сравнение добавленного списка",
    },
    addComparSueecss: {
      ID: 2409,
      CN: "加入比较列表成功",
      TR: "Успешно добавлен в список сравнения",
    },
    clearComparList: {
      ID: 2410,
      CN: "确认清除比较列表",
      TR: "Подтвердите  чтобы очистить список сравнения",
    },
    clearComparSuccess: {
      ID: 2411,
      CN: "清除比较列表成功",
      TR: "Список сравнения был успешно очищен",
    },
    confirmDelCompar: {
      ID: 2412,
      CN: "确认删除此型号的比较",
      TR: "Подтвердите удаление сравнения этой модели",
    },
    deleteSuccess: { ID: 2413, CN: "删除成功", TR: "Удалено успешно" },
    confirmDelCollect: {
      ID: 2414,
      CN: "确认删除此收藏",
      TR: "Подтверждение удаления коллекции",
    },
    confirmClearCollect: {
      ID: 2415,
      CN: "确认清除收藏",
      TR: "Подтверждение удаления коллекции",
    },
    clearCollectSueecss: { ID: 2416, CN: "清除成功", TR: "Удалено успешно" },
    collecExists: {
      ID: 2417,
      CN: "收藏已存在",
      TR: "коллекция уже существует",
    },
    collectSuccess: {
      ID: 2418,
      CN: "收藏成功",
      TR: "Коллекция уже существует",
    },
    login: { ID: 673, CN: "登录", TR: "Войти в систему" },
    information: { ID: 2419, CN: "个人信息", TR: "Информация" },
    tipInfo: {
      ID: 2420,
      CN: "您确定要退出系统吗",
      TR: "Вы уверены  что хотите выйти из системы",
    },
    tip: { ID: 289, CN: "提示", TR: "Подсказка" },
    define: { ID: 125, CN: "确定", TR: "ОК" },
    cancel: { ID: 126, CN: "取消", TR: "Отмена" },
    collectTip: { ID: 2421, CN: "收藏列表为空", TR: "Список коллекций пуст" },
    compareTip: {
      ID: 2422,
      CN: "比较列表至少需要两项",
      TR: "В списке сравнения должно быть не менее двух элементов",
    },
    accountInfo: {
      ID: 2423,
      CN: "账户信息",
      TR: "Информация об учетной записи",
    },
    accountModification: { ID: "", CN: "账户修改", TR: "Изменение счета" },
    baseInfo: { ID: 424, CN: "基本信息", TR: "Основная информация" },
    realName: { ID: 631, CN: "真实姓名", TR: "Настоящее имя" },
    account: { ID: 2424, CN: "账号", TR: "Аккаунт" },
    telPhoneNumber: { ID: 379, CN: "手机号", TR: "Мобильный номер" },
    email: { ID: 1803, CN: "邮箱", TR: "Электоронная почта" },
    corpName: { ID: 102, CN: "公司名称", TR: "Название компании" },
    corpAddress: { ID: 710, CN: "公司地址", TR: "Адрес компании" },
    code: { ID: "", CN: "编码", TR: "Код " },
    userSetting: { ID: "", CN: "用户设置", TR: "Пользовательская настройка" },
    update: {
      ID: "",
      CN: "检测到有新版本, 是否更新?",
      TR: "обнаружена новая версия, обновлена ли она?",
    },
    updateFile: {
      ID: "",
      CN: "下载更新文件中...",
      TR: "Загрузка обновления в файл...",
    },
    updateFail: {
      ID: "",
      CN: "下载更新文件失败！",
      TR: "Ошибка загрузки файла обновления!",
    },
    installFile: { ID: "", CN: "安装更新文件", TR: "установить обновить файл" },
    installCompleted: {
      ID: "",
      CN: "应用资源更新完成！",
      TR: "обновление приложения завершено!",
    },
    installFail: {
      ID: "",
      CN: "安装更新文件失败",
      TR: "Ошибка установки файла обновления",
    },
    haveCollected: {
      ID: "",
      CN: "您暂未收藏产品",
      TR: "у вас пока нет коллекции",
    },
    comparisonRequires: {
      ID: 1650,
      CN: "比较列表至少需要两项",
      TR: "В списке сравнения должно быть не менее двух элементов",
    },

    entryName: { ID: 771, CN: "项目名称", TR: "Название проекта" }, //yy add---
    companyYName: { ID: "", CN: "您的公司名", TR: "Имя вашей компании" },
    companyType: { ID: 241, CN: "类型", TR: "Тип" },
    constructionParty: {
      ID: "",
      CN: "采购方/建设方",
      TR: "Покупатель / строитель",
    },
    projectLocation: {
      ID: "",
      CN: "项目所在地",
      TR: "Местонахождение проекта",
    },
    projectCity: { ID: "", CN: "城市", TR: "Города" },
    projectArea: { ID: "", CN: "县/区", TR: "Округ / район" },
    projectDetailAddress: {
      ID: 625,
      CN: "详细地址",
      TR: "Подробный адрес",
    },
    projectNotes: { ID: "", CN: "备注说明", TR: "Примечания" },
    itemName: { ID: 771, CN: "项目名称", TR: "Название проекта" }, //项目列表
    itemNo: { ID: "", CN: "项目编号", TR: "Номер проекта" },
    item_start_EndTime: {
      ID: "",
      CN: "开始/结束时间",
      TR: "Время начала / окончания",
    },
    ConsumerName: { ID: "", CN: "业主方", TR: "Владелец" },
    PrjCreateTime: {
      ID: "",
      CN: "项目添加时间",
      TR: "Время добавления проекта ",
    },
    CustomerDistrict: { ID: "", CN: "所属区域", TR: "Регион" },
    C_Address: { ID: 191, CN: "地址", TR: "Адрес" },
    itemQuery: { ID: 246, CN: "查询", TR: "Посмотреть" },
    itemDelete: { ID: 117, TR: "删除", TR: "Удалить" },
  },
  // 底部footer 栏
  footer: {
    version: { ID: 29, CN: "版本", TR: "версия" },
    technical: {
      ID: 697,
      CN: "技术支持：上海义维流体科技有限公司",
      TR: "Техническая поддержка: Shanghai EvenTech Fluid Technology Co. Ltd.",
    },
    technicalAddres: {
      ID: "",
      CN: "备案号为：沪ICP备14049296号-2",
      TR: "Номер регистрации: Ху ICP Бэй №14049296 - 2",
    },
    copyright: {
      ID: "",
      CN: "版权所有：上海义维流体科技有限公司",
      TR: "Авторское право: ООО Компания по науке и технике жидкостной среды «И Вэй» г. Шанхай",
    },
    copyrightAddres: {
      ID: "",
      CN: "地址：上海市闵行区江月路999号1幢615",
      TR: "Адрес: пр. Цзянюе д.999, стр.1, офис 615, р-н. Миньхан, г. Шанхай",
    },
    tips: {
      ID: 2425,
      CN: "数据仅供参考：如有修改恕不通知 版权所有，盗版必究",
      TR: "данные только для справки: если есть изменение, но не уведомление авторского права",
    },
  },

  // 简易项目
  simpleProject: {
    tips1: {
      ID: "",
      CN: "请至少选中一个型号",
      TR: "Пожалуйста, выберите хотя бы одну модель.",
    },
    tips2: { ID: "", CN: "确认返回？", TR: "Подтвердить возвращение?" },
    tips3: { ID: "", CN: "确认删除此型号吗？", TR: "Удалить эту модель?" },
    tips4: { ID: "", CN: "添加失败", TR: "Ошибка добавления" },
    tips5: { ID: "", CN: "添加成功", TR: "Добавить успех" },
    tips6: { ID: "", CN: "清除收藏列表", TR: "Очистить список коллекций" },
    auto: { ID: "", CN: "自动生成", TR: "Автомобиль" },
    someAsCustomer: { ID: "", CN: "和客户一样", TR: "Некоторые как клиенты" },
    itemInfo: { ID: "", CN: "工位信息", TR: "Информация о рабочих местах" },
    creator: { ID: "", CN: "创建人", TR: "Создатель" },

    upload: { ID: "", CN: "上传", TR: "Загрузить" },
    notUpload: { ID: "", CN: "未上传", TR: "Не загружено" },
    lastEditor: { ID: "", CN: "最后编辑人", TR: "Последний редактор" },
    tips7: {
      ID: "",
      CN: "项目名称不能为空",
      TR: "Название проекта не может быть пустым",
    },
    tips8: {
      ID: "",
      CN: "此操作将删除该项目, 是否继续?",
      TR: "Эта операция удалит проект, продолжается ли?",
    },
    tips9: {
      ID: "",
      CN: "无法读取到项目信息",
      TR: "Невозможно прочитать информацию о проекте",
    },
    tips10: { ID: "", CN: "删除失败", TR: "Ошибка удаления" },
    tips11: { ID: "", CN: "删除成功", TR: "Удалить успешно" },
    tips12: { ID: "", CN: "已取消删除操作", TR: "Удалить операцию" },
    tips13: {
      ID: "",
      CN: "用户名称不能为空",
      TR: "Имя пользователя не может быть пустым",
    },
    tips14: { ID: "", CN: "请填选客户", TR: "Пожалуйста, заполните клиента." },

    tips15: { ID: "", CN: "修改成功", TR: "Изменение успешно" },
    tips16: { ID: "", CN: "修改失败", TR: "Ошибка изменения" },
    tips17: {
      ID: "",
      CN: "此操作将清空已填信息, 是否继续?",
      TR: "Эта операция очистит заполненную информацию, будет ли она продолжена?",
    },
    tips18: { ID: "", CN: "已取消操作", TR: "Операция отменена" },
  },
};
